"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.filterNameFormat = void 0;

var _camelCase = _interopRequireDefault(require("lodash/camelCase"));

const filterNameFormat = (group, filterTitle, urlDisplayName) => `${(0, _camelCase.default)(group)}-${urlDisplayName || (0, _camelCase.default)(filterTitle)}`;

exports.filterNameFormat = filterNameFormat;